import React from 'react';
import { SurfaceProps } from './surface-props';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'surface';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const SurfaceComponent = React.forwardRef<any, SurfaceProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      z,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

SurfaceComponent.displayName = 'Surface';

export const Surface = styled(SurfaceComponent)`
  background: ${props => props.theme.palette.background.surface};
  background: var(
    ${props => props.theme.vars.palette.background.surface},
    ${props => props.theme.palette.background.surface}
  );
  box-shadow: var(
    ${props => props.theme.vars.palette.background.surface},
    ${props => props.theme.palette.background.surface}
  );
  box-shadow: ${props => props.theme.shadows[props.z || 0]};
  box-shadow: var(
    ${props => props.theme.vars.shadows[props.z || 0]},
    ${props => props.theme.shadows[props.z || 0]}
  );
  border-radius: ${props => props.theme.spacing(1, 'px')};
  border-radius: calc(
    var(
        ${props => props.theme.vars.spacing},
        ${props => props.theme.spacing(1)}
      ) * 1px
  );
`;
